import(/* webpackMode: "eager" */ "/app/apps/royalur/src/app/(articles)/(learn)/dice/knucklebones.jpg");
;
import(/* webpackMode: "eager" */ "/app/apps/royalur/src/app/(articles)/(learn)/dice/opengraph-image.jpg");
;
import(/* webpackMode: "eager" */ "/app/apps/royalur/src/app/(articles)/(learn)/dice/roll_outcomes.png");
;
import(/* webpackMode: "eager" */ "/app/apps/royalur/src/app/(articles)/(learn)/dice/roll_probs_3d.png");
;
import(/* webpackMode: "eager" */ "/app/apps/royalur/src/app/(articles)/(learn)/dice/roll_probs.png");
;
import(/* webpackMode: "eager" */ "/app/apps/royalur/src/app/(articles)/(learn)/dice/stick_dice.jpg");
;
import(/* webpackMode: "eager", webpackExports: ["GameAPIProvider"] */ "/app/apps/royalur/src/components/api/GameAPIContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SubscribeToRoyalListPrompt"] */ "/app/apps/royalur/src/components/blog/SubscribeToRoyalListPrompt.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EnvProvider"] */ "/app/apps/royalur/src/components/env/EnvContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EmbeddedDice"] */ "/app/apps/royalur/src/components/game/dice/EmbeddedDice.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ShareButton"] */ "/app/apps/royalur/src/components/layout/ShareButton.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/packages/assets/src/photos/tetrahedral_dice.png");
